export default __webpack_public_path__ + "static/media/courtyard-marriott-buena-vista.821eea65.jpg";